/**
 * fakeDispatch — runs Redux thunks without a Redux store.
 * Used in class component wrappers after removing the Redux Provider.
 *
 * - If the action is a function (thunk), call it with fakeDispatch so it executes.
 * - If the action is a plain object, ignore it (all state is now in Zustand).
 */
const fakeDispatch = (action) => {
  if (typeof action === "function") {
    return action(fakeDispatch);
  }
  // plain Redux action objects are no-ops; Zustand is the source of truth
};

export default fakeDispatch;
